"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("../core");
const utils_1 = require("./utils");
function initVueRouterGuard(vueRouter, gtmInstance) {
    vueRouter.afterEach((to) => {
        var _a, _b, _c;
        const name = to.meta && typeof to.meta.gtm === 'string' && !!to.meta.gtm
            ? to.meta.gtm
            : to.name || '';
        const router = vueRouter;
        let fullUrl = ((_b = (_a = router.options) === null || _a === void 0 ? void 0 : _a.history) === null || _b === void 0 ? void 0 : _b.base) || ((_c = router.options) === null || _c === void 0 ? void 0 : _c.base) || '';
        if (!fullUrl.endsWith('/')) {
            fullUrl += '/';
        }
        fullUrl += to.fullPath.startsWith('/')
            ? to.fullPath.substr(1)
            : to.fullPath;
        gtmInstance === null || gtmInstance === void 0 ? void 0 : gtmInstance.trackView(name, fullUrl);
    });
}
exports.default = {
    install(app, options) {
        var _a;
        const gtManager = (_a = options.gtManager) !== null && _a !== void 0 ? _a : new core_1.default(options);
        if (options.vueRouter) {
            initVueRouterGuard(options.vueRouter, gtManager);
        }
        if ((0, utils_1.isVue3)(app)) {
            app.config.globalProperties.$gtm = gtManager;
        }
        else {
            app.prototype.$gtm = gtManager;
        }
    },
};
